import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Strong = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: black;
  padding: 3px 0;
`;
